/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse_SelectItem_ } from '../models/ListResponse_SelectItem_';
import { request as __request } from '../core/request';

export class AreasService {

    /**
     * Список районов города для выпадающего списка
     * @returns ListResponse_SelectItem_ Ok
     * @throws ApiError
     */
    public static async getAreas(): Promise<ListResponse_SelectItem_> {
        const result = await __request({
            method: 'GET',
            path: `/areas`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}